/** Emoji are full-colour glyphs; to recolour them we render the glyph
 *  transparent and let a zero-offset text-shadow paint its silhouette. */
export const glyphStyle = (color) =>
  color ? { color: "transparent", textShadow: `0 0 0 ${color}` } : {};
